// Presentational slot-chip row for the thread Book cascade. A tap selects a
// time; the parent stages it and reveals Send. Mirrors the home feed's slot UI
// but thread-local (zero edits to the critical TaskEricInput). Mobile-first:
// pills wrap, 44px touch targets, restrained press feedback, reduced-motion-safe.

import { Button } from '@/components/ui/button'
import type { SlotOption } from '@/lib/threads'

export function SlotPicker({
  slots,
  selectedIso,
  onSelect,
  loading,
  emptyLabel,
}: {
  slots: SlotOption[]
  selectedIso: string | null
  onSelect: (slot: SlotOption) => void
  loading: boolean
  emptyLabel: string
}) {
  if (loading) {
    return (
      <div className="flex flex-wrap gap-2">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className="h-9 w-28 animate-pulse rounded-full bg-muted/50 motion-reduce:animate-none"
          />
        ))}
      </div>
    )
  }

  if (slots.length === 0) {
    return <p className="py-1 text-sm text-muted-foreground">{emptyLabel}</p>
  }

  return (
    <div className="flex flex-wrap gap-2">
      {slots.map((slot) => {
        const selected = slot.starts_at_iso === selectedIso
        return (
          <Button
            key={slot.starts_at_iso}
            type="button"
            variant="chip"
            size="pill"
            aria-pressed={selected}
            onClick={() => onSelect(slot)}
            className={`border px-3.5 py-1.5 ${
              selected
                ? 'border-hv-accent bg-hv-accent-soft text-hv-accent [@media(hover:hover)_and_(pointer:fine)]:hover:border-hv-accent [@media(hover:hover)_and_(pointer:fine)]:hover:bg-hv-accent-soft'
                : 'border-border bg-card text-foreground [@media(hover:hover)_and_(pointer:fine)]:hover:border-muted-foreground/30 [@media(hover:hover)_and_(pointer:fine)]:hover:bg-card'
            }`}
          >
            {slot.label}
          </Button>
        )
      })}
    </div>
  )
}
